import Nav from './nav';
import MobileNav from './mobile-nav';
import Header from './header';
import Title from './title';
import TitleAnnouncer from './title-announcer';
import { titleReducer } from './title.reducer';
import { layoutReducer } from './layout.reducer';
import * as titleActions from './title.actions';

export {
  Nav,
  MobileNav,
  Header,
  Title,
  TitleAnnouncer,
  titleReducer,
  titleActions,
  layoutReducer,
}



// WEBPACK FOOTER //
// src/layout/index.js